/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// https://sheets.googleapis.com/v4/spreadsheets/1Qp52qvdsjGb5UtxeuYFvvqab-LvE7WWu6aS9J-pE22Q/values/findMyShade?key=AIzaSyDg5FKSPnwXMyJuuiduKRgDkFIwK1li47I
$(document).ready(function(){
  
  /**************************** I konw my shade functionity start here **************************/ 
  var IKMSpageUrl = window.location.href;
  console.log('2');
  if(IKMSpageUrl.indexOf('i-know-my-shade')>-1){
    var sheetData = undefined;
    var sheetKey = $('.google-sheet-api .sheet-details').attr('data-sheetKey');
    var apiKey = $('.google-sheet-api .sheet-details').attr('data-sheetApiKey');
    var sheetName = $('.google-sheet-api .sheet-details').attr('data-sheetName');
    var sheetUrl = "https://sheets.googleapis.com/v4/spreadsheets/"+sheetKey+"/values/"+sheetName+"?key="+apiKey;
    var pinJson;
    var brand=[],foundation,shade,foundationValue,brandValue,shadeValue,skin1,skin2;
    console.log('1');
    function updateData(){
      console.log('test');
      $.ajax({
        type: "GET", 
        url: sheetUrl,
        dataType: "json",
        async: false,
        success: function(data){
          sheetData = JSON.stringify(data.values);
          pinJson = JSON.parse(sheetData);
          console.log(pinJson);
        }
      });
      for(var i=1; i<pinJson.length; i++){
        if(brand.indexOf(pinJson[i][0])<0){
          brand.push(pinJson[i][0]);
        }
      }
      for(var i=0; i<brand.length; i++){
        $('#brand').append(new Option(brand[i], brand[i]));
      }

    };
    updateData();
    //   On brand chagne - update foundation
    $(document).on('change','#brand',function(){
      foundation=[];
      brandValue = $(this).val();
      //       console.log(brandValue);
      $('#foundation + .dropdown').remove();
      $('#brand1,#brand2').append(new Option(brandValue,brandValue)).val(brandValue);
      $("#foundation").find('option').remove().end().append(new Option('Select Your Foundation',''));
      console.log($("#foundation"));
      for(var i=1; i<pinJson.length; i++){
        console.log(brandValue,pinJson[i][0]);
        if(foundation.indexOf(pinJson[i][1])<0 && brandValue == pinJson[i][0]){
          foundation.push(pinJson[i][1]);
          console.log(pinJson[i][1]);
          $("#foundation").append(new Option(pinJson[i][1], pinJson[i][1]));
        }
      }

      create_custom_dropdowns();
      // on change of brand dropdown option, go to foundation page   
      $(this).closest('fieldset').find('.err-msg').hide();
      var IsOptionBrand = $(this).closest('fieldset').find('.col:not(.disabled) select').val();
      if(IsOptionBrand.length>0){
        $(this).closest('fieldset').find('.next').trigger('click');
      }

    });

    //   On foundation chagne - update shade
    $(document).on('change','#foundation',function(){
      shade=[];
      foundationValue = $(this).val();
      console.log(brandValue);
      $('#shade + .dropdown').remove();
      $('#foundation1').append(new Option(foundationValue,foundationValue)).val(foundationValue);
      $("#shade").find('option').remove().end().append(new Option('Select Your Shade',''));
      for(var i=1; i<pinJson.length; i++){
        if(shade.indexOf(pinJson[i][2])<0 && brandValue == pinJson[i][0] && foundationValue == pinJson[i][1]){
          shade.push(pinJson[i][2]);
          $("#shade").append($('<option />').val(pinJson[i][2]).text(pinJson[i][2]).attr("data-color",pinJson[i][5]));
        }
      }
      create_custom_dropdowns();
      $(this).closest('fieldset').find('.err-msg').hide();
      var IsOptionfoundation = $(this).closest('fieldset').find('.col:not(.disabled) select').val();
      if(IsOptionfoundation.length>0){
        $(this).closest('fieldset').find('.next').trigger('click');
      }
    });

    //   On foundation chagne - update shade
    $(document).on('change','#shade',function(){
      $(this).closest('fieldset').find('.err-msg').hide();
    });

    $(document).on('click','.submit-action-button',function(e){
      e.preventDefault();
      shadeValue = $('#shade').val();
      for(var i=1; i<pinJson.length; i++){
        if(brandValue == pinJson[i][0] && foundationValue == pinJson[i][1] && shadeValue == pinJson[i][2]){
          skin1 = pinJson[i][3];
          skin2 = pinJson[i][4];
        }
      }
      console.log(skin1,skin2);
      window.location.href="/pages/shade-finder-result?skin1="+skin1+"&skin2="+skin2;
    });
  }
  
  var resultPageUrl = window.location.href;
  var productData = '';
  if(resultPageUrl.indexOf('shade-finder-result')>-1){
    var pageData = resultPageUrl.split('?skin1=')[1];
    var pageData1 = pageData.split('&skin2=');
    var product1 = pageData1[0];
    var product2 = pageData1[1];
    $.ajax({
      type: "GET", 
      url: '/products/'+product1+'?view=json',
      async: false,
      success: function(data){
        productData += data;
                 console.log(data);
      }
    });
    $.ajax({
      type: "GET", 
      url: '/products/'+product2+'?view=json',
      async: false,
      success: function(data){
        productData += data;
                 console.log(data);
      }
    });
    $('.section-shade-result .shade-finder-result').html(productData);
 
    $(document).on('click','.result .buy-now',function(e){
      e.preventDefault();
      var variantId = $(this).parent('form').find('[name="id"]').val();
      console.log(variantId);
      var proQuantity = $(this).closest('.result').find('.QuantitySelector__CurrentQuantity').val();
      console.log(variantId,proQuantity);
      window.location.href = "/cart/"+variantId+":"+proQuantity;
    });

    // Quantity Selector  
//     $(document).on("click",".QuantitySelector--large .QuantitySelector__Button",function(){
//       //     alert();
//       var val = parseInt($(this).closest(".price-quantity").find(".QuantitySelector__CurrentQuantity").val());
//       var self = $(this);
//       if(self.hasClass('icon-plus')){
//         val +=1;
//       }else if(self.hasClass('icon-minus') && val > 0){
//         val -=1;
//       }
//       if(val > 0){
//         $(this).closest(".price-quantity").find(".QuantitySelector__CurrentQuantity").val(val);
//       }
//     });
  }
  /**************************** I konw my shade functionity end here **************************/ 
  
  /**************************** Find my best shade functionity start here **************************/ 
  var FMSpageUrl = window.location.href;
  if(FMSpageUrl.indexOf('find-best-shade')>-1 || $('body').hasClass('template-index')){
    var sheetData2 = undefined;
    var FMSsheetKey = $('.google-sheet-api .sheet-details').attr('data-sheetKey');;
    var FMSapiKey = $('.google-sheet-api .sheet-details').attr('data-sheetApiKey');
    var FMSsheetName = $('.google-sheet-api .sheet-details').attr('data-sheetName');
    var FMSsheetUrl = "https://sheets.googleapis.com/v4/spreadsheets/"+FMSsheetKey+"/values/"+FMSsheetName+"?key="+FMSapiKey;
    var FMSpinJson;
    function updateData(){
      $.ajax({
        type: "GET", 
        url: FMSsheetUrl,
        dataType: "json",
        async: false,
        success: function(data){
          sheetData2 = JSON.stringify(data.values);
          FMSpinJson = JSON.parse(sheetData2);
          //console.log(FMSpinJson);
        }
      });
    };
    updateData();

    $(document).on('click','.submit-action-button',function(e){
      e.preventDefault();
      var skinShade = $('.select-skin-tone .col input:checked').val().toLowerCase().replace(/ /g,"-");
      console.log('skinShade=>', skinShade);
      var coverageShade = $('.select-coverage .col input:checked').val().replace(/ /g,"-");
      var productHandle,jsonSkin,jsonCoverage, variantID;
      for(var i=1; i<FMSpinJson.length; i++){
        jsonSkin = (FMSpinJson[i][0]).toLowerCase().replace(/ /g,"-").replace(".","-");
        jsonCoverage = (FMSpinJson[i][1]).toLowerCase().replace(/ /g,"-");
        
        if(skinShade == jsonSkin && coverageShade == jsonCoverage){
          productHandle = FMSpinJson[i][2];
          variantID = FMSpinJson[i][3];
        }
      }
      
      console.log('productHandle',productHandle);
      console.log('variantID',variantID);
      
      if(variantID !== '' || variantID !== null | variantID !== undefined || variantID !== false){
        window.location.href="/products/"+productHandle+"?view=alternate&variant="+variantID;
      } else {
        window.location.href="/products/"+productHandle+"?view=alternate";
      }
      
      
    });
    
    //  Code to jump on next flow on click of selection   
    $(document).on('change','input[name="skin-tone"]',function(e){
     // $(this).closest('fieldset').find('.next').trigger('click');
    });
    var skintone, coverage;
    
    $(document).on('click','.skin-tone-slide',function(e){
      skintone = $(this).data('value');
      $(this).parents('.ShadeList').addClass('hide').next().removeClass('hide');
      $('.Shade-Tab li').eq(1).addClass('active');
      window.dispatchEvent(new Event('resize'));
    });
    
    $(document).on('click','.coverage-slide',function(e){
      coverage = $(this).data('value').toLowerCase();
      console.log({skintone,coverage});
      console.log('sheetData',sheetData2);
      
      var jsonSheetData2 = JSON.parse(sheetData2);
      console.log('jsonSheetData2',jsonSheetData2);
      var productHandle, variantID;
      for(var i = 0; i < jsonSheetData2.length; i++){
        var dataSkintone = jsonSheetData2[i][0].toLowerCase();
        var dataCoverage = jsonSheetData2[i][1].toLowerCase();
        
        if(dataSkintone == skintone && dataCoverage == coverage){
          productHandle = FMSpinJson[i][2];
          variantID = FMSpinJson[i][3];
          console.log('productHandle',productHandle);
          console.log('variantID',variantID);
        }
        
        if(variantID !== '' || variantID !== null | variantID !== undefined || variantID !== false){
          window.location.href="/products/"+productHandle+"?view=alternate&variant="+variantID;
        } else {
          window.location.href="/products/"+productHandle+"?view=alternate";
        }
      }
      
    });
    
  }
  /**************************** Find my best shade functionity end here **************************/ 
  
  /**************************** Product page functionity start here **************************/ 
  var productPageUrl = window.location.href;
  if(productPageUrl.indexOf('/products/')>-1){
    if(productPageUrl.indexOf('?view=alternate')>-1){
      $('.product-template-section .PageHeader').show();
      $('#shopify-section-related-products').remove();
    }else{
      $('#shopify-section-related-products').show();
    }
    // product page buy now button    
    $(document).on('click','.action-button-wrapper .buy-now',function(e){
      e.preventDefault();
      var variantId = $(this).closest('form').find('[name="id"]').val();
      console.log(variantId);
      var proQuantity = $(this).closest('form').find('.QuantitySelector__CurrentQuantity').val();
      console.log(variantId,proQuantity);
      window.location.href = "/cart/"+variantId+":"+proQuantity;
    });
  }
  
  /**************************** Product page functionity start here **************************/ 
  
  /**************************** WIDGET start here **************************/ 
   function form_widget() {
    //jQuery time
    var current_fs, next_fs, previous_fs; //fieldsets
    var left, opacity, scale; //fieldset properties which we will animate
    var animating; //flag to prevent quick multi-click glitches
    
    $(".next").click(function(){
      var IsOptionEmpty = $(this).closest('fieldset').find('.col:not(.disabled) select').val();
      //       console.log(IsOptionEmpty);
      if(IsOptionEmpty != undefined){
        var OptionLength = parseInt(IsOptionEmpty.length); 
        if(OptionLength < 1){
          $(this).closest('fieldset').find('.error-msg').show();
          return false;
        }else{
          $(this).closest('fieldset').find('.error-msg').hide();
        }
      }else{
        var radioOptionLength = $(this).closest('fieldset').find('input:radio:checked').length;
        console.log(radioOptionLength);
        if(radioOptionLength<1){
          $(this).closest('fieldset').find('.error-msg').show();
          return false;
        }else{
          $(this).closest('fieldset').find('.error-msg').hide();
        }
      }
      if(animating) return false;
      animating = true;

      current_fs = $(this).parent();
      next_fs = $(this).parent().next();

      //activate next step on progressbar using the index of next_fs
      $("#progressbar li").eq($("fieldset").index(next_fs)).addClass("active");

      
      
      //show the next fieldset
      next_fs.show(); 
      //hide the current fieldset with style
      current_fs.animate({opacity: 0}, {
        step: function(now, mx) {
          //as the opacity of current_fs reduces to 0 - stored in "now"
          //1. scale current_fs down to 80%
          //scale = 1 - (1 - now) * 0.2;
          //2. bring next_fs from the right(50%)
          //left = (now * 50)+"%";
          //3. increase opacity of next_fs to 1 as it moves in
          opacity = 1 - now;
//           current_fs.css({
//             'transform': 'scale('+scale+')'
//           });
          next_fs.css({'left': left, 'opacity': opacity});
        }, 
        duration: 0, 
        complete: function(){
          current_fs.hide();
          animating = false;
        }, 
        //this comes from the custom easing plugin
        easing: 'easeInOutBack'
      });
      //  animate to top
      $("html, body").animate({ scrollTop: 0 }, 500);

    });

    $(".previous").click(function(){
      console.log('prev');
      if(animating) return false;
      animating = true;
      console.log('test');

      current_fs = $(this).parents('fieldset');
      previous_fs = $(this).parents('fieldset').prev();
      
      console.log('current_fs',current_fs);
      console.log('previous_fs',previous_fs);

      //de-activate current step on progressbar
      $("#progressbar li").eq($("fieldset").index(current_fs)).removeClass("active");

      //show the previous fieldset
      previous_fs.show(); 
      //hide the current fieldset with style
      current_fs.animate({opacity: 0}, {
        step: function(now, mx) {
          //as the opacity of current_fs reduces to 0 - stored in "now"
          //1. scale previous_fs from 80% to 100%
          //scale = 0.8 + (1 - now) * 0.2;
          //2. take current_fs to the right(50%) - from 0%
          //left = ((1-now) * 50)+"%";
          //3. increase opacity of previous_fs to 1 as it moves in
          opacity = 1 - now;
          current_fs.css({'left': left});
          previous_fs.css({'opacity': opacity});
        }, 
        duration: 0, 
        complete: function(){
          current_fs.hide();
          animating = false;
        }, 
        //this comes from the custom easing plugin
        //easing: 'easeInOutBack'
      });
      //  animate to top
      $("html, body").animate({ scrollTop: 0 }, 500);
    });

  }
  
  form_widget();



  /**************************** WIDGET end here **************************/ 

  /**************************** Custom dropdown start here **************************/ 
  function create_custom_dropdowns() {
    $('fieldset select').each(function(i, select) {
      if (!$(this).next().hasClass('dropdown')) {
        $(this).after('<div class="dropdown ' + ($(this).attr('class') || '') + '" tabindex="0"><span class="current"></span><div class="list"><ul></ul></div></div>');
        var dropdown = $(this).next();
        var options = $(select).find('option');
        var selected = $(this).find('option:selected');
        var showOrHideSpan;
        dropdown.find('.current').html(selected.data('display-text') || selected.text());
        options.each(function(j, o) {
          var dataColor = $(o).attr('data-color') || ''; 
          var display = $(o).data('display-text') || '';
          dataColor == ''?showOrHideSpan='hide':showOrHideSpan='show';
          dropdown.find('ul').append('<li class="option ' + ($(o).is(':selected') ? 'selected' : '') + '" data-value="' + $(o).val() + '" data-display-text="' + display + '"><span class="'+showOrHideSpan+'" style="background-color:'+dataColor+'"></span>' + $(o).text() + '</li>');
        });
      }
    });
  }

  // Event listeners
  
  // Open/close
  $(document).on('click', '.dropdown', function(event) {
    $('.dropdown').not($(this)).removeClass('open');
    $(this).toggleClass('open');
    if ($(this).hasClass('open')) {
      $(this).find('.option').attr('tabindex', 0);
      $(this).find('.selected').focus();
    } else {
      $(this).find('.option').removeAttr('tabindex');
      $(this).focus();
    }
  });
  // Close when clicking outside
  $(document).on('click', function(event) {
    if ($(event.target).closest('.dropdown').length === 0) {
      $('.dropdown').removeClass('open');
      $('.dropdown .option').removeAttr('tabindex');
    }
    event.stopPropagation();
  });
  // Option click
  $(document).on('click', '.dropdown .option', function(event) {
    $(this).closest('.list').find('.selected').removeClass('selected');
    $(this).addClass('selected');
    var text = $(this).data('display-text') || $(this).text();
    $(this).closest('.dropdown').find('.current').text(text);
    $(this).closest('.dropdown').prev('select').val($(this).data('value')).trigger('change');
  });

  // Keyboard events
  $(document).on('keydown', '.dropdown', function(event) {
    var focused_option = $($(this).find('.list .option:focus')[0] || $(this).find('.list .option.selected')[0]);
    // Space or Enter
    if (event.keyCode == 32 || event.keyCode == 13) {
      if ($(this).hasClass('open')) {
        focused_option.trigger('click');
      } else {
        $(this).trigger('click');
      }
      return false;
      // Down
    } else if (event.keyCode == 40) {
      if (!$(this).hasClass('open')) {
        $(this).trigger('click');
      } else {
        focused_option.next().focus();
      }
      return false;
      // Up
    } else if (event.keyCode == 38) {
      if (!$(this).hasClass('open')) {
        $(this).trigger('click');
      } else {
        var focused_option = $($(this).find('.list .option:focus')[0] || $(this).find('.list .option.selected')[0]);
        focused_option.prev().focus();
      }
      return false;
      // Esc
    } else if (event.keyCode == 27) {
      if ($(this).hasClass('open')) {
        $(this).trigger('click');
      }
      return false;
    }
  });

  create_custom_dropdowns();
  /**************************** Custom dropdown end here **************************/ 


  // On Click SignUp It Will Hide Login Form and Display Registration Form
  $("#signup").click(function() {
    $("#login-tab").removeClass("active");
    $("#register-tab").addClass("active");
  });
  // On Click SignIn It Will Hide Registration Form and Display Login Form
  $("#signin").click(function() {
    $("#register-tab").removeClass("active");
    $("#login-tab").addClass("active");
  });
  

  $('#SortBy').change(function(){
    
    var val = $(this).val();
    console.log(val);
    
    $(".Popover__ValueList .Popover__Value").each(function(){
      var th_val = $(this).data('value');
      console.log(th_val);
      
      if(val == th_val){
        $(this).trigger('click');
      }
    });
  });
  
  //On Blog Page
  $('.SectionTagFilter .filter-head a').click(function(){
    $(this).parents('.Container').find('.Blog__TagList').toggleClass('active');
  });
});

$('.accordion-toggle').click(function(e) {
  console.log("t");
  e.preventDefault();

  var $this = $(this);
  
  if($(this).hasClass('active')){
  	$(this).removeClass('active');
  } else {
    $this.parent().parent().find('.accordion-item .accordion-toggle').removeClass('active');
    $(this).toggleClass('active');
  }
  
  if ($this.next().hasClass('show')) {
    $this.next().removeClass('show');
    $this.next().slideUp(350);
  } else {
    $this.parent().parent().find('.accordion-item .accordion-inner').removeClass('show');
    $this.parent().parent().find('.accordion-item .accordion-inner').slideUp(350);
    $this.next().toggleClass('show');
    $this.next().slideToggle(350);
  }
});

$('.Account__LinkItem').on('click', function(){
  $('.Drawer__Close').trigger('click');
});


var getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
    }
  }
  return false;
};

var orderid = getUrlParameter('orderid');
if(orderid){
  $('#thank-you-order-id').html(orderid);
}

$windowWidth = $(window).width();

if($('.Product__Slideshow').length && $windowWidth < 1008){
  var flkty = new Flickity('.Product__Slideshow');
  var carouselStatus = document.querySelector('.carousel-status');

  function updateStatus() {
    var slideNumber = flkty.selectedIndex + 1;
    carouselStatus.textContent = slideNumber + '/' + flkty.slides.length;
  }
  updateStatus();

  flkty.on( 'select', updateStatus );
}